import axios from "axios";
import {EventBus} from "../../event-bus";
import moment from "moment";
import _ from 'lodash';


export default {
    namespaced: true,
        state: {
            loading: false,
            error: false,
            searchTerm: undefined,
            paginationDetails: {
                from: undefined,
                to: undefined,
                total: undefined,
                currentPage: {
                    'url': "",
                    'page': 1
                },
                firstPage: {
                    'url': "",
                    'page': 1
                },
                nextPage: {
                    'url': "",
                    'page': ""
                },
                previousPage: {
                    'url': "",
                    'page': ""
                },
                lastPage: {
                    'url': "",
                    'page': ""
                },
            },
            unreadCount: 0,
            account: {
                id: auth.usergroup,
                name: auth.company
            },
            user: {
                id: auth.id,
                fullname: `${auth.firstname} ${auth.lastname}`
            },
            notifications: [],
            assignedOnly: false,
            flaggedOnly: false,
            notificationType: {'label': 'All', 'key': 'all'},
            accountList: [],
            userList: [],
            userNotificationsBaseURL: '/notifications/user',
            accountNotificationsBaseURL: '/notifications/account',
            assignedOrderNotificationsBaseURL: '/notifications/account/assigned-orders',
            showNotificationsFor: 'user',
            currentDateRangeType: 'notificationCreatedAtRange',
            displayAccountColumn: false,
            notificationCreatedAtRange: {
                "start": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                "end": moment().format('YYYY-MM-DD'),
                "shortcut": ""
            },
            orderDueDateRange: {
                "start": undefined,
                "end": undefined,
                "shortcut": ""
            },
    },
    getters: {
        requestUrl: state => {
      
            const currentPage = state.paginationDetails.currentPage.page.toString();
            const BASE_URL = window.location.origin;
      
            const rangeType = state.currentDateRangeType;
      
            let dateStart;
            let dateEnd;
      
            dateStart = state[rangeType].start;
            dateEnd = state[rangeType].end;

            // assigned notifications URL construction
            if (state.assignedOnly) {
                const assignedOrderNotificationsUrl = new URL(BASE_URL + state.assignedOrderNotificationsBaseURL);
                assignedOrderNotificationsUrl.searchParams.append("user_id", auth.id);
                if (state.searchTerm) {
                    assignedOrderNotificationsUrl.searchParams.append("search_term", state.searchTerm);
                }
                assignedOrderNotificationsUrl.searchParams.append("page", currentPage);
                assignedOrderNotificationsUrl.searchParams.append("type", state.notificationType.key);
                assignedOrderNotificationsUrl.searchParams.append("flagged_only", state.flaggedOnly ? "1" : "0");
                assignedOrderNotificationsUrl.searchParams.append("date_range_type", state.currentDateRangeType);
                assignedOrderNotificationsUrl.searchParams.append("date_start", dateStart);
                assignedOrderNotificationsUrl.searchParams.append("date_end", dateEnd);
                return assignedOrderNotificationsUrl.href;
            }
      
            if (state.showNotificationsFor === 'user') {
                const userNotificationsUrl = new URL(BASE_URL + state.userNotificationsBaseURL);
                userNotificationsUrl.searchParams.append("page", currentPage);
                if (state.searchTerm) {
                    userNotificationsUrl.searchParams.append("search_term", state.searchTerm);
                }
                userNotificationsUrl.searchParams.append("user", state.user.id);
                userNotificationsUrl.searchParams.append("type", state.notificationType.key);
                userNotificationsUrl.searchParams.append("flagged_only", state.flaggedOnly ? "1" : "0");
                userNotificationsUrl.searchParams.append("date_range_type", state.currentDateRangeType);
                userNotificationsUrl.searchParams.append("date_start", dateStart);
                userNotificationsUrl.searchParams.append("date_end", dateEnd);
                return userNotificationsUrl.href;
            }
      
            if (state.showNotificationsFor === 'account') {
                const accountNotificationsUrl = new URL(BASE_URL + state.accountNotificationsBaseURL);
                accountNotificationsUrl.searchParams.append("page", currentPage);
                if (state.searchTerm) {
                    accountNotificationsUrl.searchParams.append("search_term", state.searchTerm);
                }
                accountNotificationsUrl.searchParams.append("account", state.account?.id);
                accountNotificationsUrl.searchParams.append("type", state.notificationType.key);
                accountNotificationsUrl.searchParams.append("flagged_only", state.flaggedOnly ? "1" : "0");
                accountNotificationsUrl.searchParams.append("date_range_type", state.currentDateRangeType);
                accountNotificationsUrl.searchParams.append("date_start", dateStart);
                accountNotificationsUrl.searchParams.append("date_end", dateEnd);
                return accountNotificationsUrl.href;
            }
        },
        showingNotificationsForName: state => {
            if (state.showNotificationsFor === 'user') {
                return state.user.fullname;
            }
            else if (state.showNotificationsFor === 'account') {
                return state.account.name;
            }
        },
        hideClearFilters: state => {
          return _.isEqual({'label': 'All', 'key': 'all'}, state.notificationType) &&
        _.isEqual(state.user.id, auth.id) &&
        _.isEqual(
            state.currentDateRangeType, {
                "start": moment().subtract(1, 'months').format('YYYY-MM-DD'),
                "end": moment().format('YYYY-MM-DD'),
                "shortcut": ""
            }
        ) && !state.flaggedOnly;
        }
    },
    mutations: {
        updatePaginationDetails(state, details) {
            Object.assign(
                state.paginationDetails, {
                    from: details.from,
                    to: details.to,
                    total: details.total,
                }
            );
        },
        setNextPage(state, page) {
            Object.assign(
                state.paginationDetails, {
                    nextPage: page
                }
            );
        },
        setCurrentPage(state, page) {
            Object.assign(
                state.paginationDetails, {
                    currentPage: page
                }
            );
        },
        setFirstPage(state, page) {
            Object.assign(
                state.paginationDetails, {
                    firstPage: page
                }
            );
        },
        setLastPage(state, page) {
            Object.assign(
                state.paginationDetails, {
                    lastPage: page
                }
            );
        },
        setPreviousPage(state, page) {
            Object.assign(
                state.paginationDetails, {
                    previousPage: page
                }
            );
        },
        setAccountList: function (state, accountList) {
            state.accountList = accountList;
        },
        setUserList: function (state, users) {
            state.userList = users;
        },
        setUnreadCount(state, unreadCount) {
            state.unreadCount = unreadCount;
        },
        setSearchTerm(state, term) {
            state.searchTerm = term;
            return term;
        },
        setNotifications(state, notifications) {
            state.notifications = notifications;
        },
        setAccount(state, account) {
            state.account = account;
        },
        setUser(state, user) {
            state.user = user;
        },
        setNotificationType(state, type) {
            state.notificationType = type;
        },
        setDisplayAccountColumn(state, shouldDisplay) {
            state.displayAccountColumn = shouldDisplay;
        },
        setLoading(state, loading) {
            if (loading) {
                EventBus.$emit('loader:show');
            }
            else {
                EventBus.$emit('loader:hide');
            }
            state.loading = loading;
        },
        setError(state, hasError) {
            state.type = hasError;
        },
        setNotificationCreatedAtRange(state, newRange) {
            state.notificationCreatedAtRange = newRange;
        },
        setOrderDueDateRange(state, newRange) {
            state.orderDueDateRange = newRange;
        },
        setCurrentDateRangeType(state, newRange) {
            state.currentDateRangeType = newRange;
        },
        setShowNotificationsFor(state, value) {
            if (state.showNotificationsFor === value) {
                return;
            }
      
            state.showNotificationsFor = value;
      
        },
        toggleFlaggedOnly(state) {
            state.flaggedOnly = !state.flaggedOnly;
        },
        setAssignedOnly(state, value) {
            state.assignedOnly = value;
        },
    },
    actions: {
        async fetchNotifications({state, commit}, pagedUrl) {
            // paged URLs are autogenerated, if the user requests the next page
            // we don't use our getter
            commit('setLoading', true);
            return axios.get(pagedUrl)
            .then(
                res => {
                    const {notifications, unreadCount} = res.data;
                    const {
                        data,
                        next_page_url,
                        prev_page_url,
                        last_page,
                        first_page_url,
                        last_page_url,
                        current_page,
                        to,
                        from,
                        total
                    } = notifications;
                    commit('setNotifications', data);
                    commit('setUnreadCount', unreadCount);
                    commit(
                    'setNextPage', {
                            page: undefined, //unused
                            url: next_page_url
                        }
                );
                commit(
                    'setCurrentPage', {
                        url: undefined, //unused
                        page: current_page
                    }
                );
                commit(
                    'setFirstPage', {
                        url: first_page_url,
                        page: 1
                    }
                );
                commit(
                    'setLastPage', {
                        url: last_page_url,
                        page: last_page
                    }
                );
                commit(
                    'setPreviousPage', {
                        url: prev_page_url,
                        page: undefined //unused
                    }
                );
                commit(
                    'updatePaginationDetails', {
                        from,
                        to,
                        total,
                    }
                );
                commit('setLoading', false);
                commit('setDisplayAccountColumn', state.showNotificationsFor === 'assigned');
                }
            ).catch(
                () => {
                    commit('setLoading', false);
                    commit('setError', true);
                }
            );
        },
        async loadAccountData({commit}, accDataUrl) {
            return axios.get(accDataUrl).then(
                res => {
                    commit('setAccountList', res.data);
                }
            );
        },
        async loadViewableUsers({commit}) {
            return axios.get(`permissions/can-view/users`).then(
                res => {
                    commit('setUserList', res.data.data);
                }
            );
        },
    }
};
